module.exports = __webpack_public_path__ + "static/img/80_phase_function_Paper_PointsHejduk_Prediction.0d825a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/80_phase_function_Paper_PointsHejduk_Prediction.png
// module id = SBnN
// module chunks = 0